module.exports = __webpack_public_path__ + "static/house-7ede6fda3179f1734f9da92c54b2fd6e.jpg";